import defaultColors from '~/colors';
import oget from 'oget';
import last from 'lodash.last';

import {
    EVENT_SHOW_ERROR,
    EVENT_SHOW_SUCCESS,
    EVENTS_SHOW_ERROR,
    EVENTS_SHOW_SUCCESS
} from '../actions/event';

const defaultState = {
    ...defaultColors()
};

const parseColors = (colors) => {
    const parsed = colors.reduce((obj, { name, hex }) => {
        switch (name) {
            case 'Background':
                obj['mainBackgroundColor'] = hex;
            break;

            case 'Highlight':
                obj['liveColor'] = hex;
            break;

            case 'Highest score':
                obj['highlightColor'] = hex;
            break;

            case 'Lowest score':
                obj['dropColor'] = hex;
            break;

            case 'Non-counting score':
                obj['nonCountingScoreColour'] = hex;
            break;

            default:
                return obj;
        }

        return obj;
    }, {});

    return defaultColors(
        parsed
    );
};

export default (state = defaultState, { type, payload }) => {
    switch (type) {
        case EVENTS_SHOW_ERROR:
        case EVENT_SHOW_ERROR: {
            return { ...defaultColors() };
        }

        case EVENTS_SHOW_SUCCESS:
        case EVENT_SHOW_SUCCESS: {
            if (payload && payload.length) {
                return parseColors(
                    oget(
                        last(payload),
                        'colors',
                        []
                    )
                );
            }

            return { ...defaultColors() };
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/colors.js